export default {
    usuarios: [],
    usuarioActual: null,
    usuarioActualObj: { nombre: 'Sin User' },
    eleccionUsuarioDialog: false
}